import app from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/database'
import 'firebase/compat/storage';
import 'firebase/compat/functions';
import 'firebase/compat/firestore';

import * as DATABASE from '../../constants/database';

const config = {
	apiKey: process.env.REACT_APP_API_KEY,
	authDomain: process.env.REACT_APP_AUTH_DOMAIN,
	databaseURL: process.env.REACT_APP_DATABASE_URL,
	projectId: process.env.REACT_APP_PROJECT_ID,
	storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_APP_ID,
	measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

const devotionsDB = DATABASE.DB;

class Firebase {
	constructor() {
		app.initializeApp(config);

		this.auth = app.auth();
		this.db = app.database();
		this.firestore = app.firestore();
		this.storage = app.storage();
		this.functions = app.functions();

		this.firestore
			.enablePersistence({
				synchronizeTabs: true
			})
			.catch((error) => {
				console.log(error);
			});
	}

	// Auth API
	doCreateUserWithEmailAndPassword = (email, password) =>
		this.auth.createUserWithEmailAndPassword(email, password);

	doSignInWithEmailAndPassword = (email, password) =>
		this.auth.signInWithEmailAndPassword(email, password);

	doSignOut = () => this.auth.signOut();

	doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

	doPasswordUpdate = password =>
		this.auth.currentUser.updatePassword(password);

	// Merge Auth and DB User API
	onAuthUserListener = (next, fallback) =>
		this.auth.onAuthStateChanged(authUser => {
			if (authUser) {
				this.user(authUser.uid)
					.once('value')
					.then(snapshot => {
						const dbUser = snapshot.val();

						// default empty roles
						if (!dbUser.isAdmin) {
							dbUser.isAdmin = 0;
						}

						// merge auth and db user
						authUser = {
							uid: authUser.uid,
							email: authUser.email,
							...dbUser
						};

						next(authUser);
					});
			} else {
				fallback();
			}
		})

	// User API
	user = uid => this.db.ref(`users/${uid}`);
	
	users = () => this.db.ref('users');

	doUpdateAdmin = (uid, value) => {
		this.db.ref(`users/${uid}`)
			.update({ isAdmin: value })
			.then(console.log('admin updated'))
			.catch(error => {
				console.log(error);
				return error;
			});
		
		const updateAdminRole = this.functions.httpsCallable('updateAdminRole');
		
		updateAdminRole({
			id: uid,
			admin: value
		}).then(result => {
			console.log(result);
		}).catch(error => {
			console.log(error);
			return error;
		});
	};

	// Devotions Firestore Database API
	devotion = id => this.firestore.collection(`${devotionsDB}`).doc(`${id}`);

	devotions = () => this.firestore.collection(`${devotionsDB}`);

	doRemoveDevotion = id => this.firestore.collection(`${devotionsDB}`).doc(`${id}`).delete();

	doUpdateImage = (id, value, callback) => {
		this.firestore.collection(`${devotionsDB}`).doc(`${id}`)
			.update({ imgUrl: value })
			.then(callback)
			.catch(error => {
				return error;
			});
	}

	doPushDevotions = (source, destination, callback) => {
		const destinationCollection = this.firestore.collection(destination);

		this.firestore.collection(source).get().then((snapshot) => {
			snapshot.forEach((doc) => {
				destinationCollection
					.doc(doc.id)
					.set(doc.data());
			});
		})
		.then(callback)
		.catch((error) => {
			return error;
		});
	}

	// Storage API
	doCheckImage = (id, file, callback, errorCallback) => {
		const filename = id ? id + '.' + file.name.split('.').pop() : file.name;
		
		this.storage.ref().child(`images/${filename}`)
			.getDownloadURL()
			.then(() => callback())
			.catch(() => errorCallback());
	}

	doImageUpload = (id, file, callback) => {
		const filename = id ? id + '.' + file.name.split('.').pop() : file.name;

		this.storage.ref().child(`images/${filename}`)
			.put(file)
			.then(snapshot => {
				return snapshot.ref.getDownloadURL();
			})
			.then(url => callback(url))
			.catch(error => { 
				return error;
			});
	}

	doImageDelete = (imgUrl) => {
		this.storage.refFromURL(imgUrl)
			.delete()
			.then(console.log('File deleted.'))
			.catch(error => {
				console.log(error);
				return error;
			});
	}
}

export default Firebase;